import SEO from "components/seo";
import { useTranslation } from "react-i18next";
import Settings from "components/settings/settings";
import SettingsContainer from "containers/settings/settings";

export default function SettingsPage() {
  const { t } = useTranslation();
  return (
    <>
      <SEO title={t("settings")} />
      <SettingsContainer>
        <Settings />
      </SettingsContainer>
    </>
  );
}
